import PublicActivityType from '@/pages/publicPages/PublicActivityType/PublicActivityType';
import PublicActivityTypeSSP from '@/pages/publicPages/PublicActivityType/PublicActivityType.ssp';
import PageMetadata from '@/v2/domains/SEO/components/PageMetadata/PageMetadata';

export default function Worksheets(props) {
  return (
    <>
      <PageMetadata
        title="Spanish worksheets for kids | Rockalingua"
        description="Spanish worksheets for kids. Illustrated print-friendly worksheets. With easy exercises to reinforce themes and apply learning in context."
      />
      <PublicActivityType {...props.pageProps} />
    </>
  );
}

export const getServerSideProps = async (context) =>
  await PublicActivityTypeSSP({ context, activityType: 'worksheet' });
